// node_modules
import { FC, useEffect, useRef, useState } from "react";
import Chart, { ChartData, ElementChartOptions, PluginChartOptions, ScaleChartOptions } from "chart.js/auto";
import { _DeepPartialObject } from "chart.js/types/utils";

type TBarChartProps = {
    data: ChartData<"bar">,
    options?: _DeepPartialObject<ElementChartOptions<"bar"> & PluginChartOptions<"bar"> & ScaleChartOptions<"bar">>
}

export const BarChart: FC<TBarChartProps> = ({data, options}: TBarChartProps) => {
  const chartContainer = useRef(null);
  const [chartInstance, setChartInstance] = useState<Chart<"bar", number[], unknown> | null>(null);

  useEffect(() => {
    if (chartContainer && chartContainer.current) {
        const newChartInstance = new Chart(chartContainer.current, {
            type: "bar",
            data: data,
            options: options
        });
        setChartInstance(newChartInstance);
        return () => newChartInstance.destroy();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartContainer]);

  useEffect(() => {
    if (chartInstance) {
      chartInstance.data = data;
      chartInstance.update();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, options]);

  return (
    <div style={{ margin: "1rem 0" }}>
      <canvas ref={chartContainer} />
    </div>
  );
};
